import React from "react";
import { Modal, Button } from "react-bootstrap";
import { IconTrash, IconUserCheck, IconUserOff } from '@tabler/icons-react';
const typeColors = {
    danger: 'red',
    success: 'green',
    warning: 'yellow',
}
function ComanConfirmationModal({
  show,
  onHide,
  title,
  message, 
  onConfirm, 
  type ,
  icon, 
}) {
  const handleConfirm = () => {
    onConfirm(); 
    onHide(); 
  };


  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header className="justify-content-center" closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center">
        {icon && (
          <span className={`trash_avtar rounded-circle ${
            type === 'success' ? 'bg-green-lt' : 'bg-pink-lt'
          }`}>
            {icon}
          </span>
        )}
        {/* <p>{message}</p> */}
        <p dangerouslySetInnerHTML={{ __html: message }} />
      </Modal.Body>

      <Modal.Footer className="justify-content-center">
        <Button variant={type}  onClick={handleConfirm}>
          Confirm
        </Button>
        <Button variant="outline-secondary" onClick={onHide}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ComanConfirmationModal;
